import React from "react";
import { Document, Page, pdfjs } from "react-pdf";
import Disclaimer from "../../shared/footer/disclaimer";

const FloorplanPdf = ({ pdfFile, url, listing, index, agents }) => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  const pdfPagesCount = Array(pdfFile.pageCount)
    .fill()
    .map((_, i) => i + 1);
  return (
    <Document file={pdfFile.src}>
      {pdfPagesCount.map((page) => {
        return (
          <div id="print-floorplans" className="page-break" key={index}>
            <div className="floorplan-header">
              <div className="print-vanity-website">
                {listing.vanityDomain
                  ? listing.vanityDomain.toUpperCase()
                  : url()}
              </div>
              <div className="print-view-spacer">
                <hr className="left"></hr>
              </div>
            </div>
            <div className="floorplans" key={index}>
              <Page
                pageNumber={page}
                renderAnnotationLayer={false}
                renderTextLayer={false}
              />
            </div>
            <div className="floorplan-footer">
              <div className="floorplan-agents">{agents()}</div>
              <div className="floorplans-disclaimer">
                <Disclaimer />
              </div>
            </div>
          </div>
        );
      })}
    </Document>
  );
};

export default FloorplanPdf;



// WEBPACK FOOTER //
// ./src/components/listing-detail/print/FloorplanPdf.js